const productionConfig = {
  ENV: 'production'
}

export default productionConfig
